module.exports = __webpack_public_path__ + "img/svg/logotipo-white-d29ca5f0.svg";